import { useQuery } from '@tanstack/react-query';
import type { JSX } from 'react';

import { Async } from './Async';
import { useDpdpDeps } from './deps';
import { NoticeView } from './NoticeView';
import { NOTICE_QUERY_KEY } from './queries';

/**
 * The notice, fetched and rendered — §6's staff `/dpdp/notice` ("preview notice as client
 * sees it") and the client app's public `/privacy`, which are the same document by
 * construction rather than by discipline.
 *
 * `GET /dpdp/notice` needs no session, so this works on the client app before anyone has
 * signed in; the tenant is resolved from the `Host` header server-side.
 */
export function NoticeScreen(): JSX.Element {
  const { api } = useDpdpDeps();
  const notice = useQuery({ queryKey: NOTICE_QUERY_KEY, queryFn: () => api.readNotice() });

  return (
    <Async pending={notice.isPending} error={notice.error} data={notice.data}>
      {(document) => <NoticeView notice={document} />}
    </Async>
  );
}
